import { render, staticRenderFns } from "./BOQDetailsHeader.vue?vue&type=template&id=7cd66eff&scoped=true"
import script from "./BOQDetailsHeader.vue?vue&type=script&lang=js"
export * from "./BOQDetailsHeader.vue?vue&type=script&lang=js"
import style0 from "./BOQDetailsHeader.vue?vue&type=style&index=0&id=7cd66eff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd66eff",
  null
  
)

export default component.exports